<template>
  <section>
    <!--工具条-->

    <!--   <el-select v-model="status" @change="changeStatus" placeholder="请选择状态">
				<el-option label="待审核" value="1"></el-option>
				<el-option label="审核通过" value="2"></el-option>
                <el-option label="驳回" value="3"></el-option>
    </el-select>-->
    <!--列表-->
    <div class="operationBox" style="">
      <div class="demo-input-suffix">
        学届
        <el-select
          v-model="value1"
          placeholder="全部"
          @change="onOptionsyear"
          style="width: 200px; margin: 3px 30px 5px 7px"
          id="inputselect"
        >
          <el-option
            v-for="item in optionsyear"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <!-- 2 -->
      <div class="demo-input-suffix">
        年级
        <el-select
          v-model="value2"
          placeholder="全部"
          @change="onOptionsyear2"
          style="width: 200px; margin: 3px 30px 5px 15px"
          id="inputselect"
        >
          <el-option
            v-for="item in optionsyear2"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <div class="demo-input-suffix">
        班级
        <el-select
          v-model="value2"
          placeholder="全部"
          @change="onOptionsyear3"
          style="width: 200px; margin: 3px 40px 5px 15px"
          id="inputselect"
        >
          <el-option
            v-for="item in optionsyear3"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
      </div>
      <toolbar
        style="width: 500px"
        :buttonList="buttonList"
        @callFunction="callFunction"
      ></toolbar>
    </div>
    <el-table
      :data="users"
      highlight-current-row
      @current-change="selectCurrentRow"
      v-loading="listLoading"
      @selection-change="selsChange"
      style="
        margin: 10px auto 0px 15px;
        width: 1581px;
        border: 1px #eaeaea solid;
      "
      :header-cell-style="{
        background: '#FFEBDD',
        color: '#333333',
        textAlign: 'center',
        height: '50px',
      }"
      empty-text="暂无数据"
      :row-style="{ height: '50px' }"
      :cell-style="{ padding: '15px 0 15px 0px' }"
    >
      <!-- <el-table-column
        type="selection"
        width="50"
        align="center"
      ></el-table-column> -->
      <el-table-column
        type="index"
        width="60"
        label=" "
        align="center"
      ></el-table-column>
      <!-- <el-table-column
        prop="Id"
        label="ID"
        width="60"
        align="center"
      ></el-table-column> -->

      <el-table-column
        prop="YearName"
        label="学届"
        width="100"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>

      <el-table-column
        prop="GradeName"
        label="年级"
        width="200"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="ClassName"
        label="班级"
        width="200"
        sortable
        align="center"
      ></el-table-column>
      <el-table-column
        prop="Content"
        label="内容"
        width="200"
        sortable
        align="center"
        :show-overflow-tooltip="true"
      ></el-table-column>
      <el-table-column
        prop="Time"
        label="创建时间"
        :formatter="formatCreateTime"
        sortable
        align="center"
      ></el-table-column>
      <!-- <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="primary"
            @click="onLookDatas(scope.row.Id)"
            >课程目录</el-button
          >
        </template>
      </el-table-column> -->
      <el-table-column label="操作" width="400px" align="center">
        <template slot-scope="scope">
          <span class="SpanList" @click="handleEdit(scope.row)"
            >查看消息内容</span
          >
          <span class="SpanList" @click="LookDateil(scope.row)">阅读情况</span>
          <span class="SpanList" @click="handleDel(scope.row.IdentifierOne)"
            >删除</span
          >
        </template>
      </el-table-column>
    </el-table>
    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <!-- <el-button
        type="danger"
        @click="batchRemove"
        :disabled="this.sels.length === 0"
        >批量删除</el-button
      > -->
      <el-pagination
        layout="prev, pager, next"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="total"
        style="text-align: center; margin-top: 100px"
        background
      ></el-pagination>
    </el-col>

    <!--编辑界面-->
    <el-dialog
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-input
        v-model="editForm.Content"
        type="textarea"
        :rows="4"
        disabled
      ></el-input>
    </el-dialog>

    <!--新增界面-->
    <el-dialog
      title="新增"
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addForm"
      >
        <el-form-item label="学生名称" prop="name">
          <el-input v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="学号" prop="studentCode">
          <el-input v-model="addForm.studentCode"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password"></el-input>
        </el-form-item>
        <el-form-item label="所属学届" prop="value1">
          <el-select v-model="addForm.value1" placeholder="请选择所属学届">
            <el-option
              v-for="item in AddOptionsyear"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属年级" prop="value2">
          <el-select
            v-model="addForm.value2"
            placeholder="请选择所属年级"
            @change="getUserScroll"
          >
            <el-option
              v-for="item in AddOptionsyear2"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属班级" prop="value3">
          <el-select v-model="addForm.value3" placeholder="请选择所属班级">
            <el-option
              v-for="item in AddOptionsyear3"
              :key="item.Id"
              :label="item.Name"
              :value="item.Id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="性别">
          <el-radio-group v-model="addForm.sex">
            <el-radio label="1">男</el-radio>
            <el-radio label="2">女</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <!-- 上传 -->
    <el-dialog title="提示" :visible.sync="dialogVisibleData" width="30%">
      <el-upload
        class="image-uploader"
        :multiple="false"
        :auto-upload="true"
        :show-file-list="true"
        :before-upload="beforeUpload"
        :drag="true"
        action=""
        :limit="1"
        :on-exceed="handleExceed"
        :http-request="uploadFile"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      </el-upload>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleData = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisibleData = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <meesage-add @closed="closedFn" :isShow="meesagefalse" />
  </section>
</template>

<script>
import { quillEditor } from "vue-quill-editor"; //调用编辑器
import store from "../../store";
import util from "../../../util/date";
import {
  GetCateListByPage,
  GetSchoolMsgList,
  GetYearsInfo,
  GetGradeInfo,
  GetClassInfo,
  AddStudent,
  RestPassword,
  DelMessage,
  UpdateStudent,
  QuestionInfoDelete,
  HotQuestionInfoUpdate,
  HotQuestionInfoAdd,
  UploadFileExcel,
  ExcelSaveFile,
} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import { isString } from "../../../util/validate";
import meesageAdd from "../../components/MeesageAdd";

export default {
  components: { Toolbar, quillEditor, meesageAdd },
  data() {
    return {
      meesagefalse: false,
      passwordDialogVisible: false,
      dialogVisibleData: false,
      value1: "",
      value2: "",
      value3: "",
      isPawassrd: "",
      studentNum: "",
      studentName: "",
      optionsyear: [],
      optionsyear2: [],
      optionsyear3: [],
      AddOptionsyear: [],
      AddOptionsyear2: [],
      AddOptionsyear3: [],
      headers: {
        Authorization: "",
      },
      contentstatus: false,
      content: ``,
      editorOption: {},
      imageUrl: "",
      catelist: [],
      buttonList: [],
      currentRow: null,
      filters: {
        name: "",
      },
      users: [],
      //statusList: [{LinkUrl: '激活', value: true}, {LinkUrl: '禁用', value: false}],
      total: 0,
      page: 1,
      pagesize: 10,
      listLoading: false,
      sels: [], //列表选中列

      addDialogFormVisible: false,
      editFormVisible: false, //编辑界面是否显示
      editLoading: false,
      editFormRules: {
        CateId: [{ required: true, message: "请选择分类", trigger: "blur" }],
        QuestionTitle: [
          { required: true, message: "请输入问题", trigger: "blur" },
        ],
      },
      //编辑界面数据
      editForm: {
        Content: "",
      },

      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [{ required: true, message: "请输入学生名称", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
        studentCode: [
          { required: true, message: "请输入所属学号", trigger: "blur" },
        ],
        value1: [
          { required: true, message: "请输入所属学届", trigger: "blur" },
        ],
        value2: [
          { required: true, message: "请输入所属年级", trigger: "blur" },
        ],
        value3: [
          { required: true, message: "请输入所属班级", trigger: "blur" },
        ],
      },
      //新增界面数据
      addForm: {
        name: "",
        studentCode: "",
        value1: "",
        value2: "",
        value3: "",
        sex: "1",
        password: "",
      },
      passwordRow: 0,
    };
  },
  modules: {
    toolbar: {
      container: [
        //配置项，全部配置如上
        ["bold", "italic", "underline"],
        [{ align: [] }],
        ["image"],
      ],
      handlers: {
        image: function (value) {
          if (value) {
            document.querySelector(".avatar-uploader input").click();
          } else {
            this.quill.format("image", false);
          }
        },
      },
    },
  },
  created() {
    this.GetYearsInfo();
  },
  // computed: {
  //   editor() {
  //     return this.$refs.myQuillEditor.quill;
  //   },
  // },
  methods: {
    LookDateil(row) {
      this.$router.push({
        path: "/Hera_Popular/MessageNewDetalis",
        query: { IdentifierOne: row.IdentifierOne },
      });
    },
    // 上传文件个数超过定义的数量
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传`);
    },
    // 上传文件之前的钩子
    beforeUpload(file) {
      var testmsg = file.name.substring(file.name.lastIndexOf(".") + 1);
      console.log(testmsg);
      const extension = testmsg === "xlsx";
      const extension2 = testmsg === "xls";
      if (!extension && !extension2) {
        this.$message({
          message: "上传文件只能是xlsx或xls格式！",
          type: "error",
        });
      }

      return extension;
    },
    // 上传文件
    uploadFile(item) {
      console.log(item);
      const fileObj = item.file;
      // FormData 对象
      const form = new FormData();
      // 文件对象
      form.append("file", fileObj);
      form.append("comId", this.comId);

      console.log(form);
      UploadFileExcel(form).then((response) => {
        console.log("MediaAPI.upload");
        console.log(response);
        this.addForm.ContentUrl = response.data.url;
        console.log("filename", this.addForm.ContentUrl);
        this.$message.info("文件：" + fileObj.name + "上传成功");
        if (response.data.success) {
          ExcelSaveFile({ sFileName: response.data.url }).then((res) => {
            if (res.data.success) {
              this.dialogVisibleData = false;
            }
          });
        }
      });
    },
    Import() {
      this.dialogVisibleData = true;
    },
    onOptionsyear() {
      GetGradeInfo().then((res) => {
        // if (res.data.response.length > 0) {
        //   this.value2 = res.data.response[0].Id;
        //   //   this.onOptionsyear();
        // }
        this.optionsyear2 = res.data.response;
        this.getModules();
      });
    },
    onOptionsyear2() {
      if (this.value1 != "" && this.value2 != "") {
        GetClassInfo({
          studyYearId: this.value1,
          gradeId: this.value2,
        }).then((res) => {
          this.optionsyear3 = res.data.response;
          this.getModules();
        });
      }
    },
    onOptionsyear3() {
      this.getModules();
    },
    //获取班级列表
    GetYearsInfo() {
      GetYearsInfo().then((res) => {
        this.optionsyear = res.data.response;
      });

      //   this.onOptionsyear();
    },
    radiochange(val) {
      console.log(val);
      // if (val == 1) {
      //   this.contentstatus=false;
      // } else {
      //     this.contentstatus=true;
      // }
    },
    onEditorReady(editor) {}, // 准备编辑器
    onEditorBlur() {}, // 失去焦点事件
    onEditorFocus() {}, // 获得焦点事件
    onEditorChange() {}, // 内容改变事件
    saveHtml(event) {
      alert(this.content);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.response;
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error("上传头像图片只能是 JPG 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过 2MB!");
      }
      return isLt2M;
    },
    selectCurrentRow(val) {
      this.currentRow = val;
    },
    callFunction(item) {
      this.filters = {
        name: item.search,
      };
      this[item.Func].apply(this, item);
    },
    //性别显示转换
    formatEnabled: function (row, column) {
      return row.Enabled ? "正常" : "未知";
    },
    formatCreateTime: function (row, column) {
      return !row.Time || row.Time == ""
        ? ""
        : util.formatDate.format(
            new Date(row.Time),
            "yyyy-MM-dd"
            // "yyyy-MM-dd hh:MM:ss"
          );
    },
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getModules();
    },
    // changeStatus(val){
    //     this.statusvalue=val;
    //     this.getModules();
    // },
    //获取分类
    getCateInfo() {
      let para = {};
      GetCateListByPage(para).then((res) => {
        this.catelist = res.data.response;
      });
    },
    //获取用户列表
    getModules() {
      let para = {
        StudyYearId: this.value1 == "" ? 0 : this.value1,
        GradeId: this.value2 == "" ? 0 : this.value2,
        ClassId: this.value3 == "" ? 0 : this.value3,
        Name: this.filters.name,
        PageIndex: this.page,
        PageSize: this.pagesize,
      };
      this.listLoading = true;

      //NProgress.start();
      GetSchoolMsgList(para).then((res) => {
        if (res.data.success) {
          this.users = res.data.response.data;
          this.total = res.data.response.dataCount;
          this.listLoading = false;
          console.log(this.users);
        } else {
          this.users = [];
          this.total = 0;
          this.listLoading = false;
        }
        //NProgress.done();
      });
    },
    //删除
    handleDel(IdentifierOne) {
      // let row = this.currentRow;
      // if (!row) {
      //   this.$message({
      //     message: "请选择要删除的一行数据！",
      //     type: "error",
      //   });

      //   return;
      // }
      this.$confirm("确认删除该记录吗?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = [{ IdentifierOne: IdentifierOne }];
          DelMessage(para).then((res) => {
            if (util.isEmt.format(res)) {
              this.listLoading = false;
              return;
            }
            this.listLoading = false;
            //NProgress.done();
            if (res.data.success) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }

            this.getModules();
          });
        })
        .catch(() => {});
    },
    //显示编辑界面
    handleEdit(row) {
      this.editFormVisible = true;
      this.editForm.Content = row.Content;
    },
    closedFn() {
      this.$set(this, "meesagefalse", false);
      this.getModules();
    },
    // //显示新增界面
    handleAdd() {
      // this.meesagefalse=true;
      this.$set(this, "meesagefalse", true);
      // this.addFormVisible = true;
      // GetYearsInfo().then((res) => {
      //   this.AddOptionsyear = res.data.response;
      //   GetGradeInfo().then((res) => {
      //     this.AddOptionsyear2 = res.data.response;
      //   });
      // });
    },
    // 年级下拉事件
    getUserScroll() {
      if (this.addForm.value1 != "" && this.addForm.value2 != "") {
        GetClassInfo({
          studyYearId: this.addForm.value1,
          gradeId: this.addForm.value2,
        }).then((res) => {
          this.AddOptionsyear3 = res.data.response;
        });
      }
    },
    editUserScroll() {
      if (this.editForm.StudyYearName != "" && this.editForm.GradeName != "") {
        console.log(this.editForm.StudyYearId);
        GetClassInfo({
          studyYearId: this.isString(this.editForm.StudyYearName)
            ? this.editForm.StudyYearId
            : this.editForm.StudyYearName,
          gradeId: this.editForm.GradeName,
        }).then((res) => {
          this.AddOptionsyear3 = res.data.response;
        });
      }
    },
    isString(str) {
      return str instanceof String || typeof str == "string";
    },
    //编辑
    editSubmit: function () {
      this.headers.Authorization = "Bearer " + store.state.token;
      this.$confirm("确定编辑该内容?", "提示", {
        type: "warning",
      })
        .then(() => {
          this.listLoading = true;
          //NProgress.start();
          let para = Object.assign({}, this.editForm);
          console.log(para);
          let params = {
            Id: this.editForm.Id,
            studyYearId: this.isString(para.StudyYearName)
              ? this.editForm.StudyYearId
              : para.StudyYearName,
            gradeId: para.GradeName,
            classId: this.isString(para.StudyYearName)
              ? this.editForm.ClassId
              : para.ClassName,
            name: para.Name,
            code: para.StudentCode,
            sex: para.Sex,
          };
          UpdateStudent(params).then((res) => {
            console.log(res, "-");
            if (res.data.success) {
              this.$message({
                message: "编辑成功",
                type: "success",
              });
              this.editFormVisible = false;
              this.getModules();
              console.log(this.editFormVisible);
            }
          });
        })
        .catch(() => {});
    },
    //新增
    addSubmit: function () {
      let _this = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {}).then(() => {
            this.addLoading = true;
            //NProgress.start();
            let params = {
              studyYearId: _this.addForm.value1,
              gradeId: _this.addForm.value2,
              classId: _this.addForm.value3,
              name: _this.addForm.name,
              code: _this.addForm.studentCode,
              sex: _this.addForm.sex,
              password: _this.addForm.password,
            };
            AddStudent(params).then((res) => {
              if (res.data.success) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.addFormVisible = false;
                this.getModules();
              }
            });
          });
        }
      });
    },
    //批量删除
    batchRemove: function () {
      this.$message({
        message: "该功能未开放",
        type: "warning",
      });
    },
    selsChange: function (sels) {
      console.log(sels);
      let ids = [];
      sels.map((item) => {
        ids.push(item.Id);
      });
      console.log(ids);
      this.sels = ids;
    },
  },
  mounted() {
    this.getModules();
    this.getCateInfo();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    this.headers.Authorization = "Bearer " + store.state.token;
  },
};
</script>

<style scoped>
.operationBox {
  box-sizing: border-box;
  padding-left: 30px;
  display: flex;
  width: 100%;
  margin-top: 20px;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-bottom: -20px;
}
.demo-input-suffix {
  /* width: 200px; */
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #666666;
  margin-left: 20px;
}
.btnQuery {
  display: flex;
  justify-content: center;
  align-items: center;
}
.el-input {
  width: 150px;
  margin: 10px;
}
.el-select {
  margin: 10px;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
}
.avatar {
  width: 320px;
  height: 180px;
  display: block;
}
</style>
